module.exports = __webpack_public_path__ + "img/france-external-causes-female.9a494be3.png";